'use strict';
import angular from 'angular';
import pinterestAudienceHtmlUrl from './views/pinterestAudienceList.html';
import pinterestChildDataHtmlUrl from './views/pinterestRecursiveTemplate.html';
let app = angular.module('app.pinterestAudience.component', []);

app.component('pinterestAudienceTargeting', {
    bindings: {
        showActions: '=',
        selectedPinterestAudience: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId:'='
    },
    templateUrl: pinterestAudienceHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService) {
        let self = this;

        self.intrestsList = [];
        self.pinterestChildDataHtmlUrl = pinterestChildDataHtmlUrl;

        self.IsChildObjectVisible = function(parent, child){
            let searchKey = $scope.search;
            let returnVal = true;
            if (undefined != searchKey && null != searchKey && searchKey.length > 0) {
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.handleSelectSubChild = function (item, child, selectedPinterestAudience, indx, type) {
            if(type == "Interests") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedPinterestAudience.intrests.indexOf(child);
                    selIndex = _.findIndex(selectedPinterestAudience.intrests, {id: child.id});
                    if (selIndex >= 0) {
                        selectedPinterestAudience.intrests.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedPinterestAudience.intrests.push(child);
                }
            }
        }

        self.addOverlap = function(data){
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            if(data.excludeAdded){
                self.hideExclude = true;
            }
            let excluded_index = _.findIndex(self.selectedPinterestAudience, { excludeAdded: true });
            if(excluded_index >=0){
                let exclude_data = self.selectedPinterestAudience[excluded_index];
                self.selectedPinterestAudience.splice(excluded_index,1);
            }
            self.selectedPinterestAudience.push({intrests: [],
                overLapEnabled:true,
                overLapAdded: true ,
                excludeEnabled:self.hideExclude ? false :true,
                intrestsList:angular.copy(self.intrestsList)
            });
            if(exclude_data){
                self.selectedPinterestAudience.push(exclude_data);
            }
        }

        self.excludeAudience = function(data){
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            self.selectedPinterestAudience.push({intrests: [],
                overLapEnabled:true,
                overLapAdded:false,
                excludeAdded:true,
                excludeEnabled:false,
                intrestsList:angular.copy(self.intrestsList)
            });
        }

        self.removeAudienceSet = function(data,index){
            if (self.selectedPinterestAudience.length == index + 1) {
                self.selectedPinterestAudience.splice(index, 1);
                let selIndex = index - 1;
                if (selIndex >= 0) {
                    self.selectedPinterestAudience[selIndex].excludeEnabled = true;
                    self.selectedPinterestAudience[selIndex].overLapEnabled = true;
                    if (data.excludeAdded) {
                        self.hideExclude = false;
                    }
                }
            } else{
                self.selectedPinterestAudience.splice(index, 1);
                if (data.excludeAdded) {
                    self.hideExclude = false;
                    let indexVal = self.selectedPinterestAudience.length-1;
                    self.selectedPinterestAudience[indexVal].excludeEnabled = true;
                }
            }
        }

        self.clearSelectedData = function(item,totalList){
            _.each(totalList,function(e){
                if(e.id == item.id){
                    e.status = '';
                    e.isChecked = false;
                }
                if(e.childData && e.childData.length > 0){
                    self.clearSelectedData(item,e.childData)
                }
            })
        }

        let processIntrestsData = function () {
            _.each(self.selectedPinterestAudience, function (data) {
                _.each(data.intrests, function (item) {
                    _.each(data.intrestsList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if(e.childData && e.childData.length > 0){
                            processSubIntrests(e.childData,data.intrests);
                        }
                    })
                })
            })
        }

        let processSubIntrests = function(childData,selectedIntrests){
            _.each(selectedIntrests,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if(e.childData && e.childData.length > 0){
                        processSubIntrests(e.childData,selectedIntrests);
                    }
                })
            })
        }

        self.getIntrests = function () {
            ProductService.getInterestsContentForPinterest().then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        let intrests = {};
                        intrests.id = content.id;
                        intrests.name = content.name;
                        intrests.status = "";
                        intrests.isChecked = false;
                        intrests.parentName = content.parentName;
                        intrests.childData = content.childData;
                        intrests.type = content.type;
                        self.intrestsList.push(intrests);
                    });
                    _.each(self.selectedPinterestAudience,function(item){
                        item.intrestsList = angular.copy(self.intrestsList);
                    })
                    processIntrestsData();
                }
            }, function (error) { });
        }

        self.handleSelectIntrests = function (intrests, selectedPinterestAudience) {
            if (!intrests.isChecked) {
                intrests.status = '';
                intrests.isChecked = false;
                let selIndex = selectedPinterestAudience.intrests.indexOf(intrests);
                if (selIndex >= 0) {
                    selectedPinterestAudience.intrests.splice(selIndex, 1);
                } else {
                    if (selectedPinterestAudience.intrests && selectedPinterestAudience.intrests.length > 0) {
                        if (_.find(selectedPinterestAudience.intrestsList, { id: intrests.id })) {
                            let index = _.findIndex(selectedPinterestAudience.intrestsList, { id: intrests.id });
                            selectedPinterestAudience.intrests.splice(index, 1);
                        }
                    }
                }
            } else {
                intrests.status = 'selected';
                intrests.isChecked = true;
                selectedPinterestAudience.intrests.push(intrests);
            }
        }

        //method to handle parent selection
        self.handleSelectParent = function (parent, data) {
            if (parent.parentChecked) {
                // Parent is selected, unselect all child items
                _.each(parent.childData, function (childItem) {
                    childItem.isChecked = false;
                });
            }
        };

        //method to handle child selection
        self.handleSelectChild = function (parent, child, data) {
            if (child.isChecked) {
                // Child is selected, unselect parent
                parent.parentChecked = false;
            } else {
                // Child is unselected, check if all children are unselected
                let allUnchecked = _.every(parent.childData, function (childItem) {
                    return !childItem.isChecked;
                });
                if (allUnchecked) {
                    parent.parentChecked = true;
                }
            }
        };

        self.removeIntrests = function (item, selectedIntrests, intrestsList) {
            let selIndex = selectedIntrests.indexOf(item);
            if (selIndex >= 0) {
                selectedIntrests.splice(selIndex, 1);
                self.clearSelectedData(item,intrestsList);
            }
        }

        self.setExclude = function(){
            _.each(self.selectedPinterestAudience,function(item){
                if(item.excludeAdded){
                    self.hideExclude = true;
                }
            })
        }


        self.initComponent = function () {
            if (self.selectedPinterestAudience && !_.isEmpty(self.selectedPinterestAudience)) {
                self.selectedPinterestAudience= JSON.parse(self.selectedPinterestAudience);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getIntrests();
                    self.setExclude();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedPinterestAudience = [{
                    intrests: [],
                    overLapEnabled:true,
                    excludeEnabled:true
                }];
                self.enableViewMode = false;
                self.getIntrests();
            }
        };

        self.initComponent();

    }

});
